import styled, { css } from 'styled-components'

import { ButtonWrapper } from '@/components/Button/Button.styles'
import { PriceWrapper } from '@/components/Price/Price.styles'

export const SummaryBarWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 1.5rem;
  height: ${props => props.theme.size.bottomBar};
  justify-content: flex-end;
  flex-shrink: 0;
  border-top: 1px solid ${props => props.theme.color.line};
  background-color: ${props => props.theme.color.body};

  ${ButtonWrapper} {
    ${props =>
      props.theme.fontSize === 'md' &&
      css`
        min-width: 12rem;
      `};
    ${props =>
      props.theme.fontSize === 'lg' &&
      css`
        min-width: 10rem;
      `};
    ${props =>
      props.theme.fontSize === 'xl' &&
      css`
        min-width: 8rem;
      `};
    &:first-child {
      margin-right: auto;
    }
  }
`

export const SummaryBarTotal = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1.5rem;
  font-size: 1.1rem;

  svg {
    fill: ${props => props.theme.color.secondaryIntense};
    margin-right: 0.5rem;
    width: 1.5rem;
    height: 1.5rem;
  }

  ${PriceWrapper} {
    font-size: 1.75rem;
    font-weight: 600;
    margin-left: 0.75rem;
  }
`
